export type Tutorial = {
  name: string;
  link: string;
  type: TutorialsType;
  img: string;
};

export enum TutorialsType {
  Article = "Article",
  Video = "Video",
}

const TutorialImage = {
  channelGrowthSecret:
    "/images/tutorials/TutorialImage.channelGrowthSecret.jpg",
  chatPinnedSpot: "/images/tutorials/TutorialImage.chatPinnedSpot.jpg",
  customPackage: "/images/tutorials/TutorialImage.customPackage.jpg",
  effectiveAds: "/images/tutorials/TutorialImage.effectiveAds.jfif",
  frytheFish: "/images/tutorials/TutorialImage.frytheFish.jpg",
  funnelAction: "/images/tutorials/TutorialImage.funnelAction.jpg",
  funnelAqcuire: "/images/tutorials/TutorialImage.funnelAqcuire.jpg",
  funnelAwarness: "/images/tutorials/TutorialImage.funnelAwarness.jpg",
  funnelDecision: "/images/tutorials/TutorialImage.funnelDecision.jpg",
  funnelDefinition: "/images/tutorials/TutorialImage.funnelDefinition.jpg",
  funnelimprove1: "/images/tutorials/TutorialImage.funnelimprove1.jpg",
  funnelimprove2: "/images/tutorials/TutorialImage.funnelimprove2.jpg",
  guideVideosIntroduction:
    "/images/tutorials/TutorialImage.guideVideosIntroduction.jfif",
  packages: "/images/tutorials/TutorialImage.Packages.jpg",
  retention: "/images/tutorials/TutorialImage.retention.jfif",
  trustInphotography: "/images/tutorials/TutorialImage.trustInphotography.jpg",
  vieworclickAds: "/images/tutorials/TutorialImage.vieworclickAds.jpg",
  onboardingIntroduction:
    "/images/tutorials/TutorialImage.onboardingIntroduction.jpg",
  baleAdvertisingPanel:
    "/images/tutorials/TutorialImage.baleAdvertisingPanel.jpg",
  extensiveAdvertising:
    "/images/tutorials/TutorialImage.extensiveAdvertising.jpg",
  thecostofAdvertising:
    "/images/tutorials/TutorialImage.thecostofAdvertising.jpg",
  clothAdvertising: "/images/tutorials/TutorialImage.clothAdvertising.jpg",
  adsBale: "/images/tutorials/TutorialImage.adsBale.jpeg",
  ppc: "/images/tutorials/TutorialImage.ppc.jpg",
  visitingAds: "/images/tutorials/TutorialImage.visitingAds.jpg",
  majale: "/images/tutorials/majale.jpg",
  need: "/images/tutorials/need.jpg",
  others: "/images/tutorials/others.jpg",
  post: "/images/tutorials/post.jpg",
  strategic: "/images/tutorials/strategic.jpg",
  text: "/images/tutorials/text.jpg",
  income_80: "/images/tutorials/income_80.jpg",
  onboardingAds: "/images/tutorials/TutorialImage.onboarding_ads_in_bale.jpg",
  pinnedInPanel: "/images/tutorials/TutorialImage.pinnedInPanel.jpg",
  changeContentStrategy:
    "/images/tutorials/TutorialImage.changeContentStrategy.jpg",
};

export enum links {
  Onboarding = "https://www.aparat.com/v/c1NmS",
  Packages = "https://www.aparat.com/v/W54Zc",
  GhifAgahi = "https://www.aparat.com/v/u7QdH",
  ViewOrClick = "https://www.aparat.com/v/Dh28p",
  Ghif = "https://www.aparat.com/v/sip51",
}

export const articlesData: Tutorial[] = [
  {
    name: "راهنمای استفاده از پنل تبلیغات بله | نحوه ثبت تبلیغات بله",
    link: "https://blog.bale.ai/bale-advertising-panel/",
    type: TutorialsType.Article,
    img: TutorialImage.baleAdvertisingPanel,
  },
  {
    name: "تبلیغات بازدیدی چیست و چطور در بله تبلیغات بازدیدی ثبت کنیم؟",
    link: "https://blog.bale.ai/visiting-ads/",
    type: TutorialsType.Article,
    img: TutorialImage.visitingAds,
  },
  {
    name:
      "تبلیغات کلیکی یا ppc و مزایای آن؛ چطور در بله تبلیغات کلیکی انجام دهیم؟",
    link: "https://blog.bale.ai/ppc/",
    type: TutorialsType.Article,
    img: TutorialImage.ppc,
  },
  {
    name: "تبلیغات گسترده در بله ؛ معرفی تبلیغات گسترده و مزایای آن",
    link: "https://blog.bale.ai/extensive-advertising/",
    type: TutorialsType.Article,
    img: TutorialImage.extensiveAdvertising,
  },
  {
    name:
      "مزایای تبلیغات در بله؛ چطور در بله تبلیغ کنیم و هزینه تبلیغات در بله چقدر است؟",
    link: "https://blog.bale.ai/the-cost-of-advertising-in-bale/",
    type: TutorialsType.Article,
    img: TutorialImage.thecostofAdvertising,
  },
  {
    name:
      "بهترین متن تبلیغاتی برای جذب مشتری لباس و ایده‌های تبلیغاتی برای فروش بیشتر",
    link: "https://blog.bale.ai/cloth_advertising/",
    type: TutorialsType.Article,
    img: TutorialImage.clothAdvertising,
  },
  {
    name: "تبلیغات در بله؛ بهتر دیده شوید!",
    link: "https://blog.bale.ai/ads-bale/",
    type: TutorialsType.Article,
    img: TutorialImage.adsBale,
  },
  {
    name: "کسب‌وکارتان را در جایگاه آنبوردینگ بله معرفی کنید!",
    link: "https://blog.bale.ai/onboarding_ads/",
    type: TutorialsType.Article,
    img: TutorialImage.onboardingAds,
  },
];

export const videosData: Tutorial[] = [
  {
    name: "مجله؛ بستر معرفی مطالب پربازدید",
    link: "https://www.aparat.com/v/H0qbO",
    type: TutorialsType.Video,
    img: TutorialImage.majale,
  },
  {
    name: "نیازسازی در مخاطب",
    link: "https://www.aparat.com/v/I5SYA",
    type: TutorialsType.Video,
    img: TutorialImage.need,
  },
  {
    name: "گفت‌وگو با مشتریان برای شناخت محصولات مکمل",
    link: "https://www.aparat.com/v/Df5IM",
    type: TutorialsType.Video,
    img: TutorialImage.others,
  },
  {
    name: "جایگاه جدید تبلیغاتی بله",
    link: "https://www.aparat.com/v/7YC59",
    type: TutorialsType.Video,
    img: TutorialImage.post,
  },
  {
    name: "تغییر استراتژی محتوایی کانال",
    link: "https://www.aparat.com/v/y3wLq",
    type: TutorialsType.Video,
    img: TutorialImage.strategic,
  },
  {
    name: "فرمول افزایش ۸۰ درصدی درآمد",
    link: "https://www.aparat.com/v/k8AU0",
    type: TutorialsType.Video,
    img: TutorialImage.income_80,
  },
  {
    name: "تعامل با مشتریان؛ متنی یا صوتی؟",
    link: "https://www.aparat.com/v/xtbwY",
    type: TutorialsType.Video,
    img: TutorialImage.text,
  },
  {
    name: "راهنمای گام‌به‌گام ثبت تبلیغ در پنل تبلیغات بله",
    link: "https://www.aparat.com/v/WgIou",
    type: TutorialsType.Video,
    img: TutorialImage.pinnedInPanel,
  },
  {
    name: "معرفی جایگاه تبلیغاتی تب گفتگو",
    link: "https://www.aparat.com/v/OLciY",
    type: TutorialsType.Video,
    img: TutorialImage.chatPinnedSpot,
  },
  {
    name: "تبلیغات بازدیدی و تبلیغات کلیکی",
    link: "https://www.aparat.com/v/Dh28p",
    type: TutorialsType.Video,
    img: TutorialImage.vieworclickAds,
  },
  {
    name: "راز رشد کانال",
    link: "https://www.aparat.com/v/KZg4e",
    type: TutorialsType.Video,
    img: TutorialImage.channelGrowthSecret,
  },
  {
    name: "تغییر استراتژی محتوایی کانال",
    link: "https://www.aparat.com/v/y3wLq",
    type: TutorialsType.Video,
    img: TutorialImage.changeContentStrategy,
  },
  {
    name: "قیف بازاریابی: آگاهی بخشی",
    link: "https://www.aparat.com/v/u7QdH",
    type: TutorialsType.Video,
    img: TutorialImage.funnelAwarness,
  },
  {
    name: "تعریف قیف بازاریابی",
    link: "https://www.aparat.com/v/sip51",
    type: TutorialsType.Video,
    img: TutorialImage.funnelDefinition,
  },
  {
    name: "تبلیغات اثرگذار",
    link: "https://www.aparat.com/v/swULy",
    type: TutorialsType.Video,
    img: TutorialImage.effectiveAds,
  },
  {
    name: "معرفی جایگاه تبلیغاتی آنبوردینگ",
    link: "https://www.aparat.com/v/c1NmS",
    type: TutorialsType.Video,
    img: TutorialImage.onboardingIntroduction,
  },
  {
    name: "معرفی ویدئوهای آموزشی تبلیغات",
    link: "https://www.aparat.com/v/ya8nu",
    type: TutorialsType.Video,
    img: TutorialImage.guideVideosIntroduction,
  },
  {
    name: "قیف بازاریابی: جذب کاربر",
    link: "https://www.aparat.com/v/7XPjB",
    type: TutorialsType.Video,
    img: TutorialImage.funnelAqcuire,
  },
  {
    name: "قیف بازاریابی: تصمیم گیری",
    link: "https://www.aparat.com/v/UpSZY",
    type: TutorialsType.Video,
    img: TutorialImage.funnelDecision,
  },
  {
    name: "قیف بازاریابی: خرید یا اقدام",
    link: "https://www.aparat.com/v/gTGkw",
    type: TutorialsType.Video,
    img: TutorialImage.funnelAction,
  },
  {
    name: "بازگشت و نگهداری کاربران",
    link: "https://www.aparat.com/v/WI5EF",
    type: TutorialsType.Video,
    img: TutorialImage.retention,
  },
  {
    name: "بهینه سازی قیف بازاریابی ۱",
    link: "https://www.aparat.com/v/Bd73U",
    type: TutorialsType.Video,
    img: TutorialImage.funnelimprove1,
  },
  {
    name: "بهینه سازی قیف بازاریابی ۲",
    link: "https://www.aparat.com/v/W9L0e",
    type: TutorialsType.Video,
    img: TutorialImage.funnelimprove2,
  },
  {
    name: "بسته های پنل تبلیغات بله",
    link: "https://www.aparat.com/v/I2f5q",
    type: TutorialsType.Video,
    img: TutorialImage.packages,
  },
  {
    name: "بسته های اختصاصی تبلیغات بله",
    link: "https://www.aparat.com/v/W54Zc",
    type: TutorialsType.Video,
    img: TutorialImage.customPackage,
  },
  {
    name: "ماهی باید توی روغن خودش سرخ بشه!",
    link: "https://www.aparat.com/v/M1OGr",
    type: TutorialsType.Video,
    img: TutorialImage.frytheFish,
  },
  {
    name: "اعتمادسازی در عکاسی از محصولات",
    link: "https://www.aparat.com/v/3pO8s",
    type: TutorialsType.Video,
    img: TutorialImage.trustInphotography,
  },
];
